exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".HowToPlay__back-button___ap_ix{position:absolute;top:20px;left:20px}.HowToPlay__slide___FX_CN{position:absolute;width:100%;height:100%}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/how-to-play/HowToPlay.scss"],"names":[],"mappings":"AAAA,gCAAa,kBAAkB,SAAS,SAAS,CAAC,0BAAO,kBAAkB,WAAW,WAAW,CAAC","file":"HowToPlay.scss","sourcesContent":[".back-button{position:absolute;top:20px;left:20px}.slide{position:absolute;width:100%;height:100%}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"back-button": "HowToPlay__back-button___ap_ix",
	"backButton": "HowToPlay__back-button___ap_ix",
	"slide": "HowToPlay__slide___FX_CN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib?{"modules":true,"importLoaders":1,"sourceMap":true,"localIdentName":"[name]__[local]___[hash:base64:5]","camelCase":true,"namedExport":true,"url":false}!./node_modules/sass-loader/lib/loader.js!./src/ts/app/screens/how-to-play/HowToPlay.scss
// module id = 226
// module chunks = 0